// extracted by mini-css-extract-plugin
export default {"root":"HSkAkCt4","label":"_574pTb1k","field":"_9-6Gfmaa","textarea":"_6Y4Tac9A","isFailed":"BlnwtK7h","error":"feztv00f","textareaCounter":"At3nLvjV","submit":"Li3pEZsT"};